/* empai-clear-sheet-size-error */
(function () {
  function piecesRoot() {
    return document.querySelector(".cut-container--pieces, [data-empai-custom-pieces]");
  }
  function clearStale() {
    if (!piecesRoot()) return;
    document.querySelectorAll(".cut-size-error.cut-message").forEach(function (el) {
      var text = el.textContent || "";
      if (/Could not read the selected sheet size/i.test(text)) {
        el.classList.remove("active");
        el.textContent = "The width or length is too big.";
      }
    });
    // Prefer pieces-order validation on EmpAI catalog PDPs
    window.falkenValidateCutItem = function () { return true; };
    var prev = window.falkenValidateAllCuts;
    window.falkenValidateAllCuts = function (showErrors) {
      if (!piecesRoot()) return prev ? prev(showErrors) : true;
      var order = window.__falkenPiecesOrder;
      if (order && order.sheetVariantId && order.pieceCount > 0) return true;
      if (typeof window.calcPriceWithCutItems === "function") {
        try { window.calcPriceWithCutItems(); } catch (e) {}
      }
      order = window.__falkenPiecesOrder;
      return !!(order && order.sheetVariantId && order.pieceCount > 0);
    };
  }
  clearStale();
  setInterval(clearStale, 250);
  document.addEventListener("DOMContentLoaded", clearStale);
  window.addEventListener("load", clearStale);
})();
